export const rfidFormatterMixin = {
    methods: {
        rfidFormatter(rfids) {
            if (!rfids) return "";
            if (typeof rfids == 'string' || rfids instanceof String) {
                return rfids?.split(",").join(" - ")
            }
            if (rfids.length) {
                let rfidsArr = []
                rfids?.forEach(rfid => {
                    if (rfid.mapping_value) rfidsArr.push(...rfid.mapping_value.split(","))
                })
                return rfidsArr.join(" - ")
            }
        }
    }
}

//timesheet / users not on site